module.exports = __webpack_public_path__ + "static/media/title.962b3d6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/title.png
// module id = 223
// module chunks = 0